export var TagLoggerString;
(function (TagLoggerString) {
    TagLoggerString["ON_TAG_EVENT"] = "onTagEvent:";
    TagLoggerString["ON_PLAYER_EVENT"] = "onPlayerEvent:";
    TagLoggerString["RESET_TAG"] = "resetTag:";
    TagLoggerString["PLAYER_DESTROY_REQUEST_CALLBACK"] = "playerDestroyRequestCallback:";
    TagLoggerString["INITIALIZE"] = "initialize:";
    TagLoggerString["EXECUTE_PLAYER_CREATE_EVENT"] = "executeCreatePlayerRequest:";
    TagLoggerString["SET_DAI_SSB_IU"] = "set_DAI_SSB_IU";
})(TagLoggerString || (TagLoggerString = {}));
